import type { Types } from '../model';

export const useSiteTemplateApi = () => {
  const { $jsonApi } = useNuxtApp();

  const fetchAll = async () => {
    return (await $jsonApi.prefix('api').all('site_template').get<Types.ISiteTemplate[]>()).data;
  };

  const select = async (templateId: string) => {
    await $jsonApi.prefix(`api/site-templates/${templateId}/apply`).post();
  };

  return { fetchAll, select };
};
